import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, flightType }) => ({
  ...theme.mixins.flexColumn,
  ...(flightType !== FLIGHT_TYPE_CF ? { borderRadius: "0 4px 4px 0" } : { borderRadius: 4 }),
  backgroundColor: theme.palette.white,
  width: 266,
  height: 60,
  position: "relative",
  cursor: "pointer",
  transition: "all .2s ease",
  border: `1px solid ${theme.palette.borderLight}`,

  "&:hover": {
    borderColor: theme.palette.borderDefault,
    boxShadow: `0 2px 4px ${theme.palette.shadowSm}`,
  },

  [theme.down("xl")]: {
    width: 226,
  },

  [theme.down("lg")]: {
    width: 186,
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "100%" : 248,
  },

  [theme.down("sm")]: {
    width: "100%",
    borderRadius: 4,
  },
}));

export const ClassBlock = styled("div")(({ theme }) => ({
  ...theme.paddings(4, 15, 0),
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.textMuted,
}));

export const PassengersCountBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  paddingLeft: 15,
  paddingTop: 2,
}));

export const PassengerCount = styled("div")(({ theme }) => ({
  ...theme.paddings(0, 10, 0, 15),
  fontSize: 14,
  position: "relative",

  "& > svg": {
    position: "absolute",
    left: -14,
    top: -10,
  },
}));

export const DropdownIcon = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  padding: 4,
  position: "absolute",
  right: 5,
  top: 18,
  color: theme.palette.textMuted,
  transition: "all .3s ease",
  transform: "rotate(0deg)",

  "&.active": {
    transition: "all .3s ease",
    transform: "rotate(180deg)",
  },
}));

export const DropdownPassengersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 5,
}));

export const DropdownPassengerItem = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
}));

export const DropdownPassengerItemTitleAndDescription = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,

  "& .title": {
    fontSize: 12,
    color: theme.palette.textPrimary,
  },

  "& .description": {
    fontSize: 10,
    color: theme.palette.textMuted,
  },
}));

export const CounterBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  fontSize: 30,
  color: theme.palette.textPrimary,

  "& span": {
    fontSize: 14,
    width: 20,
    textAlign: "center",
  },

  "& > svg": {
    cursor: "pointer",
    color: theme.palette.textPrimary,

    "&.disabled": {
      cursor: "default",
      color: theme.palette.textMuted,
    },
  },
}));

export const ClassesBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 5,
  paddingTop: 15,
}));

export const ClassButton = styled("button")(({ theme, position }) => ({
  ...(position ? { gridColumn: position } : {}),
  backgroundColor: "transparent",
  color: theme.palette.textMuted,
  border: `1px solid ${theme.palette.borderDefault}`,
  borderRadius: 4,
  height: 32,
  cursor: "pointer",
  transition: "all .2s ease",
  fontWeight: 500,

  "&:hover": {
    borderColor: theme.palette.primaryLight,
    color: theme.palette.primaryLight,
    backgroundColor: theme.palette.primarySubtle,
  },

  "&.active": {
    backgroundColor: theme.palette.primaryLight,
    borderColor: theme.palette.primaryLight,
    color: theme.palette.white,

    "&:hover": {
      backgroundColor: theme.palette.primaryDark,
      borderColor: theme.palette.primaryDark,
    },
  },
}));
